module.exports = __webpack_public_path__ + "img/wg.daca9678.png";